import { render, staticRenderFns } from "./EducationalCoursesDetail.vue?vue&type=template&id=368d1c82&scoped=true&"
import script from "./EducationalCoursesDetail.vue?vue&type=script&lang=js&"
export * from "./EducationalCoursesDetail.vue?vue&type=script&lang=js&"
import style0 from "./EducationalCoursesDetail.vue?vue&type=style&index=0&id=368d1c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d1c82",
  null
  
)

export default component.exports